import { Heading, Section, Stack } from "@carbon/react";
import { FC } from "react";
import { FormProvider, UseFormReturn } from "react-hook-form";

import CaseTypeSinglePickerFormField from "src/components/Pickers/CaseTypeSinglePickerFormField.tsx";
import { useT } from "src/internationalization";

import { CaseTypeSelectionData } from "./useCaseTypeSelection";

export type CaseTypeSelectionProps = {
  methods: UseFormReturn<CaseTypeSelectionData>;
};

export const CaseTypeSelection: FC<CaseTypeSelectionProps> = ({ methods }) => {
  const t = useT();

  return (
    <Stack gap={6} className="mb-4">
      <Section level={3}>
        <Heading className={"ml-0"}>
          {t("page.rules.modal.create.linkedCase.form.caseType.title")}
        </Heading>
      </Section>
      <FormProvider {...methods}>
        <div id="case-type-selection">
          <CaseTypeSinglePickerFormField
            name="selectedCaseType"
            titleText={t("page.rules.modal.create.linkedCase.form.caseType.title")}
            helperText={t("page.rules.modal.create.linkedCase.form.caseType.helper")}
          />
        </div>
      </FormProvider>
    </Stack>
  );
};
